import React from 'react';
import PropTypes from 'prop-types';
import { getItemName, getItemLink } from '../utils';
import { transformSideMenuOrder } from './utils';
import './index.scss';

const source = 'side-menu';

const SideMenu = ({ category, categorySlug, alignedSidemenuOrder }) => {
    const orderedItems = alignedSidemenuOrder ? category.items : transformSideMenuOrder(category.items, categorySlug);

    return (
        <div className="side-menu">
            <ul>
                <li className="selected-category">{category.title}</li>
                {orderedItems.map((item, index) => (
                    <li key={index}>
                        <a href={item && getItemLink(item.type, item.urlParams, source)}>
                            {item && getItemName(item.alias, item.type, item.urlParams)}
                        </a>
                    </li>))}
            </ul>
        </div>
    );
};

SideMenu.propTypes = {
    category: PropTypes.object
};

export default SideMenu;